import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import IllustrationThumb from 'components/IllustrationThumb';
import { Container, Header, ShowMore, Title, InnerContainer, LoaderTitle } from './styles';
import { AddCircle } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useRouter } from 'next/router';
import { setLocale } from 'utils/locale';

import en from './locale/en';
import ja from './locale/en';
import zh from './locale/en';
import es from './locale/es';
import fr from './locale/fr';
import it from './locale/it';

const Props = {
  title: PropTypes.string.isRequired,
  onTitleClick: PropTypes.func,
  children: PropTypes.node.isRequired,
};

const LoaderProps = {
  numberOfItems: PropTypes.number,
};

const LoaderDefaultProps = {
  numberOfItems: 8,
};

function Loader({ numberOfItems }) {
  const items = [];

  for (let i = 0; i < numberOfItems; i++) {
    items.push(<IllustrationThumb.Loader key={uuid()} />);
  }

  return (
    <Container>
      <LoaderTitle />
      <InnerContainer>{items}</InnerContainer>
    </Container>
  );
}

Loader.propTypes = LoaderProps;
Loader.defaultProps = LoaderDefaultProps;

export default function IllustrationsCategorySection({ title, onTitleClick, children }) {
  const router = useRouter();
  const { locale } = router;
  const t = setLocale(locale, { en, es, fr, it, ja, zh });

  return (
    <Container>
      <Header>
        <Title onClick={onTitleClick}>{title}</Title>

        <ShowMore type="button" onClick={onTitleClick}>
          {t.seeMoreText}
          <Box ml={1}>
            <AddCircle fontSize="small" />
          </Box>
        </ShowMore>
      </Header>
      <InnerContainer>{children}</InnerContainer>
    </Container>
  );
}

IllustrationsCategorySection.propTypes = Props;
IllustrationsCategorySection.Loader = Loader;
IllustrationsCategorySection.defaultProps = {
  onTitleClick: undefined,
};
